import { BONUS_TOP, BONUS_MIDDLE, BONUS_BOTTOM } from "./data";
import { random } from "core/math";

export const bonusLayout = {
  _place: BONUS_MIDDLE,
  _places: [BONUS_TOP, BONUS_MIDDLE, BONUS_BOTTOM],

  get place(): number {
    return this._place;
  },

  replace(): void {
    this._place = this._places[(random() * this._places.length) | 0];
  },

  firstPlace(): void {
    this._place = BONUS_MIDDLE;
  },
};
